import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "PurchaseConditionListPage" */
	'pages/supplier/PurchaseCondition/PurchaseConditionListPage'));

export default [{ component, exact: true, path: '/purchase_conditions' }];